import { SvgIcon, SxProps, Theme } from "@mui/material";
import { ReactElement } from "react";

export default function ExistingBlockSvg({
    sx,
}: {
    sx?: SxProps<Theme>;
}): ReactElement {
    return (
        <SvgIcon
            viewBox="0 0 20 20"
            sx={{ width: 20, height: 20, fill: "none", ...sx }}
        >
            <g mask="url(#mask0_1174_34079)">
                <path
                    d="M7.16927 18.75L5.58594 16.0833L2.58594 15.4167L2.8776 12.3333L0.835938 10L2.8776 7.66667L2.58594 4.58333L5.58594 3.91667L7.16927 1.25L10.0026 2.45833L12.8359 1.25L14.4193 3.91667L17.4193 4.58333L17.1276 7.66667L19.1693 10L17.1276 12.3333L17.4193 15.4167L14.4193 16.0833L12.8359 18.75L10.0026 17.5417L7.16927 18.75ZM7.8776 16.625L10.0026 15.7083L12.1693 16.625L13.3359 14.625L15.6276 14.0833L15.4193 11.75L16.9609 10L15.4193 8.20833L15.6276 5.875L13.3359 5.375L12.1276 3.375L10.0026 4.29167L7.83594 3.375L6.66927 5.375L4.3776 5.875L4.58594 8.20833L3.04427 10L4.58594 11.75L4.3776 14.125L6.66927 14.625L7.8776 16.625ZM9.1276 12.9583L13.8359 8.25L12.6693 7.04167L9.1276 10.5833L7.33594 8.83333L6.16927 10L9.1276 12.9583Z"
                    fill="#1A62F2"
                />
            </g>
        </SvgIcon>
    );
}
